import script from "./VNumericCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./VNumericCard.vue?vue&type=script&setup=true&lang=ts"

import "./VNumericCard.vue?vue&type=style&index=0&id=1ce4adf1&lang=scss"

const __exports__ = script;

export default __exports__